import React from "react";

const LocationSearchInputContext = React.createContext(null);

export default LocationSearchInputContext;
